import React from 'react';

const ChallengeCard = ({
  challenge,
  isJoined,
  showProgress,
  isCreator,
  onJoin,
  onLeave,
  onEdit,
  onDelete,
  onViewLeaderboard
}) => {
  const getBadgeClass = (type) => {
    const classes = {
      distance: 'challenge-card__badge--distance',
      streak: 'challenge-card__badge--streak',
      specific: 'challenge-card__badge--specific'
    };
    return classes[type] || '';
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short'
    });
  };

  const progress = challenge.progress || 0;
  const progressPercent = Math.min((progress / challenge.target_value) * 100, 100);

  return (
    <div className="challenge-card">
      <div className="challenge-card__header">
        <h3 className="challenge-card__title">{challenge.title}</h3>
        <span className={`challenge-card__badge ${getBadgeClass(challenge.challenge_type)}`}>
          {challenge.challenge_type}
        </span>
      </div>

      {challenge.description && (
        <p className="challenge-card__description">{challenge.description}</p>
      )}

      <div className="challenge-card__target">
        <span className="challenge-card__target-value">{challenge.target_value}</span>
        <span className="challenge-card__target-unit">{challenge.target_unit}</span>
      </div>

      {showProgress && isJoined && (
        <div className="challenge-card__progress">
          <div className="challenge-card__progress-bar">
            <div
              className="challenge-card__progress-fill"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
          <div className="challenge-card__progress-text">
            <span>{progress} / {challenge.target_value} {challenge.target_unit}</span>
            <span>{Math.round(progressPercent)}%</span>
          </div>
        </div>
      )}

      <div className="challenge-card__meta">
        <span>{formatDate(challenge.start_date)} - {formatDate(challenge.end_date)}</span>
        <span className="challenge-card__participants">
          {challenge.participant_count || 0} participants
        </span>
      </div>

      <div className="challenge-card__footer">
        <div className="challenge-card__footer-row">
          <button className="btn-leaderboard" onClick={onViewLeaderboard}>
            Leaderboard
          </button>
          {!isCreator && (
            isJoined ? (
              <button className="btn-leave" onClick={onLeave}>
                Leave
              </button>
            ) : (
              <button className="btn-join" onClick={onJoin}>
                Join
              </button>
            )
          )}
        </div>
        {isCreator && (
          <div className="challenge-card__footer-row">
            <button className="btn-edit" onClick={onEdit}>
              Edit
            </button>
            <button className="btn-delete" onClick={onDelete}>
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChallengeCard;
